// extracted by mini-css-extract-plugin
export default {"nav":"menuCategoryNav_nav__94Vws","label":"menuCategoryNav_label__gioDD"};